import {PickedProperty, pickProperty} from '../../../../core/graphql/graphql-utils'
import {JobRequestDetail_GetOfferingGql, JobRequestDetail_GetOfferingQuery} from '../../../../../__generated__/types'
import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {ResolverUtilService} from '../../../../core/resolver/resolver-util.service'
import {Observable, of} from 'rxjs'
import {catchError, map} from 'rxjs/operators'
import {OTHER_OFFERING_ID} from '../../../../core/i18n/link.service'

export type OfferingResolved = PickedProperty<JobRequestDetail_GetOfferingQuery, 'offeringById'>

@Injectable({providedIn: 'root'})
export class JobRequestOfferingResolver {
  constructor(
    private getOfferingGql: JobRequestDetail_GetOfferingGql,
    private util: ResolverUtilService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<OfferingResolved> {
    const offeringId = route.parent?.paramMap.get('offeringId')
    const intentionSlug = route.paramMap.get('intentionSlug')
    if (!offeringId) {
      return this.util.redirectToNotFound(state.url, {reportError: true})
    }

    if (offeringId === OTHER_OFFERING_ID) {
      return of(undefined)
    }

    return this.getOfferingGql.fetch({offeringId}).pipe(
      map(res => pickProperty(res.data, 'offeringById')),
      map(offering => {
        if (intentionSlug) {
          const intention = offering?.intentions?.find(i => i.slug === intentionSlug)
          if (!intention) {
            this.util.redirectToNotFound(state.url, {reportError: true})
            return undefined
          }
        }
        return offering
      }),
      catchError(e => this.util.handleError(e, state.url)),
    )
  }
}
